import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useSiteSettings } from '@/contexts/SiteSettingsContext';
import MaintenancePage from '@/pages/MaintenancePage';

/**
 * Renders MaintenancePage for all visitors when settings.maintenance_mode === true.
 * Always allows admin users and the /admin + /login routes to pass through so the
 * mode can be toggled off by the operator.
 */
const ALLOWED_PATHS = ['/admin', '/login'];

export default function MaintenanceGate({ children }) {
  const { settings, loading: settingsLoading } = useSiteSettings();
  const { user, loading: authLoading } = useAuth();
  const { pathname } = useLocation();

  if (settingsLoading || authLoading) return null;

  const isMaintenance = !!settings?.maintenance_mode;
  if (!isMaintenance) return children;

  // Admins always pass through (can disable the toggle from /admin)
  if (user?.role === 'admin') return children;

  // Whitelisted paths (admin login etc.) always accessible
  if (ALLOWED_PATHS.some((p) => pathname === p || pathname.startsWith(p + '/'))) {
    return children;
  }

  return <MaintenancePage />;
}
